<script context="module"></script>

<script>import { setContext } from "svelte";
import { writable } from "svelte/store";
import BuilderContext from "../../../context/builder.context";
import Block from "../block.svelte";
export let repeatContext;
export let block;
export let registeredComponents;
export let linkComponent;
let store = writable(repeatContext);
setContext(BuilderContext.key, store);
</script>

<Block {block} context={store} {registeredComponents} {linkComponent} />